// URL base del backend propio del menu (NO es la API de Loyverse).
// El frontend nunca llama a api.loyverse.com: el token se queda en el servidor.
//
// En produccion (Vercel) el backend vive en el mismo proyecto bajo /api
// (ver bliss-menu/api/index.py). Ese backend, si hay LOYVERSE_ACCESS_TOKEN,
// pide items y categorias a https://api.loyverse.com/v1.0.
//
// En desarrollo local: python api/index.py o python ../sumup-backend/app.py
// y REACT_APP_API_URL=http://localhost:5000
export const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";
